/**
 * Provides information about dark mode availability and activation.
 */
class DarkMode {
  constructor() {
    console.log('darkmode ' + (this.isEnabled() ? 'enabled' : 'disabled'));
    console.log('darkmode ' + (this.isActivated() ? 'activated' : 'not activated'));
  }

  /**
   * Returns true if dark mode is active.
   */
  isActivated() {
    return this.isEnabled() && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  }

  /**
   * Returns true if dark mode is available for use.
   */
  isEnabled() {
    return document.documentElement.getAttribute('data-theme') === 'user-preferred';
  }
}

export default new DarkMode();
